
export default function AutoCompleteDirective($timeout) {
    'ngInject';
    return function (scope, element, attrs) {
        element.autocomplete({
            source: scope[attrs.uiItems],
            select: function () {
                $timeout(function () {
                    element.trigger('input');
                }, 0);
            }
        });
    };
}
